<template>
    <div ref="boxCard" class="box-card" >
        <div class="box-content">
            <div class="box-content-header">
                <span class="box-name">{{userList.real_name || userList.name}}</span>
                <span class="box-identity">律师</span>
                <img src="/static/img/isviplawyer.png" alt="" v-if="userList.isVip == 1 ? true : false">
            </div>
            <div class="lawoffice">
                {{userList.company}}
            </div>
            <div class="box-tags">
                <span v-for="(item, index) in userList.speciality" :key="index">{{item.name}}</span>
            </div>
            <div class="box-description">
                <span class="ellipsis2">描述: &nbsp;&nbsp;{{userList.profile}}</span>
            </div>
            <div class="box-grade">
                <div class="box-star clearfix">
                    <span>
                        律师星级:
                    </span>
                    <!-- <el-rate
                        v-model="userList.star"
                        disabled
                        text-color="#ff9900"
                     >
                    </el-rate> -->
                    <img src="/static/img/praise3_is.png" alt="" v-for="item in userList.star" :key="'star' + item" class="box-star-star">
                    <img src="/static/img/praise3.png" alt="" v-for="item in userList.isStar" :key="'isStar' + item" class="box-star-star2">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value5: 3.7
        }
    },
    props: {
        flowModule: {
            type: Boolean,
            default: false
        },
        userList: Object
    },
    methods: {
        boxCard(item,e) {
            if (this.flowModule) {
                // let e = event || window.event
                // console.log(e, '2')
                let dom = this.$refs.boxCard
                dom.style.position = 'fixed'
                dom.style.left = e.clientX + -139 + 'px'
                dom.style.top = e.clientY + 20 +  'px'
                dom.style.zIndex = 100
            }
            // console.log(e, 3)
        }
    }
}
</script>

<style scoped lang="stylus">
.box-card
    width 278px
    box-shadow: 0 0 30px rgba(133, 153, 162, 0.3)
    background #fff
    border-radius 4px
    .box-content
        padding 13px 25px 0
        height 260px
        .box-content-header
            height 33px
            line-height 33px
            .box-name
                font-size 18px
                color $textcolor
                font-weight bold
            .box-identity
                font-size 16px
                margin-left 12px
                margin-right 10px
            img
                width 17px
                height 17px
                vertical-align middle
                margin-top -4px
        .lawoffice
            font-size 14px
            height 25px
            line-height 25px
            color #999
        .box-tags
            // height 47px
            margin 5px 0
            // line-height 47px
            span
                display inline-block
                padding 5px 12px
                color #959595
                margin 0 2px
                background #f8f8f8
                font-size 12px
                border-radius 15px
            span:nth-child(1)
                margin-left 0
        .box-description
            font-size 12px
            color #444
            margin-top 10px
            height 50px
            border-bottom 1px solid #f6f6f6
            span
                line-height 20px
        .box-grade
            margin-top 16px
            .box-star
                height 26px

                font-size 0
                line-height 26px
                span
                    color #444
                    font-size 12px
                    margin-right 5px
                    float left
                .box-star-star
                    width 18px
                    height 18px
                    margin 2px 3px 0 2px

                .box-star-star2
                    width 18px
                    height 18px
                    margin 2px 3px 0 2px

                // .el-rate
                //     float left
                //     margin-top 3px
                //     margin-left 5px

    .box-footer
        height 40px
        background #faf9f9
        display flex
        span
            flex 1
            display flex
            align-items center
            i
                display inline-block
                width 22px
                height 22px
                margin 0 6px
                cursor pointer
                display flex
        span:nth-child(1)
            justify-content flex-end


</style>



// WEBPACK FOOTER //
// src/components/userInfo/index.vue